import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import GradeIcon from "@material-ui/icons/Grade";
import {
  Tooltip,
  Icon,
  TableRow,
  TableCell,
  Collapse,
} from "@material-ui/core";
import moment from "moment";

import Header from "../../../partials/header";
import TableFormat from "../../../partials/TableFormat";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import { formatDatetime } from "../../../utils/setting";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import Edit from "./editContent";
import { styles } from "./styles";
const headCells = [
  {
    key: "title",
    numeric: false,
    disablePadding: false,
    label: "digital_signal_list_title",
  },
  {
    key: "creator",
    numeric: false,
    disablePadding: false,
    label: "digital_signal_list_creator",
  },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "digital_signal_list_created",
  },
  {
    key: "totalMedia",
    numeric: false,
    disablePadding: false,
    label: "digital_signal_list_total_media",
  },
  {
    key: "isActive",
    numeric: false,
    disablePadding: false,
    label: "digital_signal_list_is_active",
  },
];

class ListDigital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
    };
    this.deleteDigital = this.deleteDigital.bind(this);
  }
  componentDidMount() {
    this.getList();
  }
  getList = async (payload) => {
    this.loading.startLoading();
    await this.props.getList(payload);
    this.loading.stopLoading();
  };
  finishUpdate = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    check.code === 1
      ? this.mSnackbar.handleClick(t("update_degital_signal_success"))
      : this.mSnackbar.handleClick(
          t("update_degital_signal_unsuccess: " + check.error),
          "error"
        );
    this.props.getList();
  };
  async deleteDigital(selected = []) {
    let { t } = this.props;
    if (selected && selected.length) {
      this.loading.startLoading();
      let check = await this.props.deleteDigital(selected);
      this.loading.stopLoading();
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("digital_signal_list_delete_success"));
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("digital_signal_list_delete_unsuccess"),
          "error"
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"), "warning");
      return false;
    }
  }
  handleOpenCollapes = (id) => {
    const listDigital = this.props.listDigital;
    const collapse = this.state.collapse;
    for (var i = 0; i <= listDigital.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };
  renderCollapse = (row, index) => {
    const { classes, listDigital } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow
        key={index}
        className={classes.tableRowHeight}
        className={classes.tableCellInCollapes}
      >
        <TableCell
          colSpan={8}
          padding={"none"}
          className={classes.tableCellEdit}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <Edit data={listDigital[index]} finishUpdate={this.finishUpdate} />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  renderActive = (isActive) => {
    if (isActive == 1) {
      return (
        <Tooltip title="Campaign active">
          <Icon color="secondary">
            <GradeIcon />
          </Icon>
        </Tooltip>
      );
    } else return null;
  };
  render() {
    const { t, history, listDigital = [], count = 0, total = 0 } = this.props;
    const { collapse } = this.state;
    return (
      <React.Fragment>
        <Header
          session={t("sidebar_cms")}
          title={t("digital_signal_title_list")}
          button={t("digital_signal_title_create")}
          actionButton={() => history.push("/digital/create")}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          contentDialog={t(
            "digital_signal_list_do_you_want_to_remove_digital_from_list"
          )}
          onDelete={this.deleteDigital}
          title={t("digital_signal_title_list")}
          showCheckBox={true}
          showFilter={false}
          showActionToolbar={false}
          placeholder={t("digital_signal_search")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={listDigital.map((row, index) => {
            let validPhone = _parsePhoneNumber(
              row.creator.countryCode,
              row.creator.username
            ).format_internal;
            return {
              id: row._id,
              title: row.title,
              creator: (
                <React.Fragment>
                  <div>
                    {" "}
                    {`${row.creator.firstName} ${row.creator.lastName}`}
                  </div>
                  <div> {validPhone}</div>
                </React.Fragment>
              ),
              createdAt: formatDatetime(row.createdAt),
              totalMedia: row.media.length,
              isActive: this.renderActive(row.isActive),
            };
          })}
        />
      </React.Fragment>
    );
  }
}
ListDigital.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listDigital: state.digitalSignal.listDigital,
  total: state.digitalSignal.total,
  count: state.digitalSignal.count,
});
const mapDispatch = (dispatch) => ({
  getList: dispatch.digitalSignal.getList,
  deleteDigital: dispatch.digitalSignal.deleteDigital,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(ListDigital)
  )
);
